import { UAParser } from "ua-parser-js";
import { encode } from "../../network/Encode";
export class Device {
    static isTouchDevice() {
        return ("ontouchstart" in window &&
            window.navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)|(Windows Phone)|(IEMobile)|(iemobile)|(Opera Mini)|(BlackBerry)/i) !== null);
    }
    static isMobile() {
        const ua = new UAParser();
        if (/Nokia T21/.test(ua.getUA())) {
            return false;
        }
        return ua.getDevice().type === "mobile";
    }
}
function shouldRedirectDueToDevice() {
    if (!Device.isTouchDevice()) {
        return false;
    }
    const ua = new UAParser();
    return (ua.getDevice().vendor === "Apple" ||
        ua.getBrowser().name === "Edge" ||
        ua.getBrowser().name === "IE");
}
function tryOpenBankIdAppWithRedirect(autostarttoken, isLysaApp) {
    const location = window.location.href;
    let path = location.split("#")[0];
    const ua = new UAParser();
    const isChrome = ua.getBrowser().name === "Chrome";
    const isIos = ua.getOS().name === "iOS";
    if (isChrome && isIos) {
        path = "googlechrome://";
    }
    if (isLysaApp) {
        path = "lysa://";
    }
    let url = getBaseBankIdPath() +
        encode `?autostarttoken=${autostarttoken}&redirect=${path}`;
    window.location.href = url;
}
function getBaseBankIdPath() {
    const ua = new UAParser();
    const os = ua.getOS().name;
    if (os === "iOS") {
        return `https://app.bankid.com/`;
    }
    return `bankid:///`;
}
function tryOpenBankIdApp(autostarttoken) {
    window.location.href =
        getBaseBankIdPath() +
            encode `?autostarttoken=${autostarttoken}&redirect=null`;
}
export function openBankidApp(autostarttoken, isLysaApp = false) {
    if (shouldRedirectDueToDevice()) {
        tryOpenBankIdAppWithRedirect(autostarttoken, isLysaApp);
        return;
    }
    tryOpenBankIdApp(autostarttoken);
}
